import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import pathParse from 'path-parse'
import SecureLS from 'secure-ls'

const ENC_KEY = process.env.VUE_APP_ENC_KEY
var ls = new SecureLS({ isCompression: false, encryptionSecret: ENC_KEY })

// add all from modules directory
let modules = {}
function importAll(allModules) {
    allModules.keys().forEach(key => {
        modules[pathParse(key).name] = allModules(key).default
    })
}
importAll(require.context('./modules/', false, /\.js$/))

Vue.use(Vuex)

export default new Vuex.Store({
    plugins: [createPersistedState({
        storage: {
            getItem: (key) => ls.get(key),
            setItem: (key, value) => ls.set(key, value),
            removeItem: (key) => ls.remove(key)
        }
    })],
    modules: modules
})
